import TableContainerReactTable from 'Components/Common/TableContainerReactTable';
import React, { useMemo } from 'react';
import { Row, Col, ButtonGroup, UncontrolledDropdown,  DropdownMenu, DropdownToggle, Button, DropdownItem } from 'reactstrap';

const StockTab: React.FC = () => {

  const data = [
    {
      productId: 'P001',
      size: 'Small',
      colour: 'Red',
      productCode: 'TSH-RD-SM',
      productName: 'Classic Cotton T-Shirt',
      active: true,
      available: 150,
      allocated: 25,
      pending: 10,
      backOrder: 5,
      onOrder: 200
    },
    {
      productId: 'P002',
      size: 'Medium',
      colour: 'Blue',
      productCode: 'TSH-BL-MD',
      productName: 'Classic Cotton T-Shirt',
      active: true,
      available: 125,
      allocated: 30,
      pending: 8,
      backOrder: 0,
      onOrder: 150
    },
    {
      productId: 'P003',
      size: 'Large',
      colour: 'Green',
      productCode: 'TSH-GR-LG',
      productName: 'Classic Cotton T-Shirt',
      active: false,
      available: 75,
      allocated: 15,
      pending: 5,
      backOrder: 12,
      onOrder: 100
    },
    {
      productId: 'P004',
      size: 'Small',
      colour: 'Black',
      productCode: 'HOD-BK-SM',
      productName: 'Premium Cotton Hoodie',
      active: true,
      available: 85,
      allocated: 20,
      pending: 15,
      backOrder: 8,
      onOrder: 120
    },
    {
      productId: 'P005',
      size: 'Medium',
      colour: 'White',
      productCode: 'HOD-WH-MD',
      productName: 'Premium Cotton Hoodie',
      active: true,
      available: 95,
      allocated: 18,
      pending: 12,
      backOrder: 3,
      onOrder: 80
    },
    {
      productId: 'P006',
      size: 'Large',
      colour: 'Gray',
      productCode: 'HOD-GY-LG',
      productName: 'Premium Cotton Hoodie',
      active: true,
      available: 110,
      allocated: 22,
      pending: 7,
      backOrder: 0,
      onOrder: 90
    },
    {
      productId: 'P007',
      size: 'Small',
      colour: 'Navy',
      productCode: 'JKT-NV-SM',
      productName: 'Windbreaker Jacket',
      active: false,
      available: 45,
      allocated: 12,
      pending: 3,
      backOrder: 15,
      onOrder: 60
    },
    {
      productId: 'P008',
      size: 'Medium',
      colour: 'Red',
      productCode: 'JKT-RD-MD',
      productName: 'Windbreaker Jacket',
      active: true,
      available: 65,
      allocated: 16,
      pending: 9,
      backOrder: 7,
      onOrder: 75
    },
    {
      productId: 'P009',
      size: 'Large',
      colour: 'Yellow',
      productCode: 'CAP-YL-LG',
      productName: 'Baseball Cap',
      active: true,
      available: 200,
      allocated: 35,
      pending: 20,
      backOrder: 2,
      onOrder: 300
    },
    {
      productId: 'P010',
      size: 'One Size',
      colour: 'Purple',
      productCode: 'CAP-PP-OS',
      productName: 'Baseball Cap',
      active: true,
      available: 180,
      allocated: 40,
      pending: 18,
      backOrder: 0,
      onOrder: 250
    }
  ];

  const columns = useMemo(() => [
    { header: 'Product Id', accessorKey: 'productId', enableColumnFilter: false, cell: (cell: any) => (<div>{cell.getValue()}</div>) },
    { header: 'Size', accessorKey: 'size', enableColumnFilter: false, cell: (cell: any) => (<div>{cell.getValue()}</div>) },
    { header: 'Colour', accessorKey: 'colour', enableColumnFilter: false, cell: (cell: any) => (<div>{cell.getValue()}</div>) },
    { header: 'Product Code', accessorKey: 'productCode', enableColumnFilter: false, cell: (cell: any) => (<div>{cell.getValue()}</div>) },
    { header: 'Name', accessorKey: 'productName', enableColumnFilter: false, cell: (cell: any) => (<div>{cell.getValue()}</div>) },
    {
      header: 'Active',
      accessorKey: 'active',
      enableColumnFilter: false,
      cell: (cell: any) => (<div>{cell.getValue() ? 'Yes' : 'No'}</div>)
    },
    {
      header: 'Available',
      accessorKey: 'available',
      enableColumnFilter: false,
      cell: (cell: any) => (<div>{cell.getValue()}</div>)
    },
    {
      header: 'Allocated',
      accessorKey: 'allocated',
      enableColumnFilter: false,
      cell: (cell: any) => (<div>{cell.getValue()}</div>)
    },
    {
      header: 'Pending',
      accessorKey: 'pending',
      enableColumnFilter: false,
      cell: (cell: any) => (<div>{cell.getValue()}</div>)
    },
    {
      header: 'Back Order',
      accessorKey: 'backOrder',
      enableColumnFilter: false,
      cell: (cell: any) => (<div>{cell.getValue()}</div>)
    },
    {
      header: 'On Order',
      accessorKey: 'onOrder',
      enableColumnFilter: false,
      cell: (cell: any) => (<div>{cell.getValue()}</div>)
    },
  ], []);



  return (
    <div className="stock-tab">
      <fieldset className="border rounded m-1 p-2">
        <Row className='justify-content-between mb-2'>
          <Col xs={6} sm={6} md={4} lg={3} className='d-flex justify-content-start'>
            <Button className='btn-soft-info btn-sm'>
              De-active Product Locations
            </Button>
          </Col>
          <Col xs={6} sm={6} md={4} lg={3} className='d-flex justify-content-end'>
            <ButtonGroup>
              <UncontrolledDropdown>
                <DropdownToggle tag="button" className="btn btn-light btn-sm">
                  Select stock list <i className="mdi mdi-chevron-down"></i>
                </DropdownToggle>
                <DropdownMenu>
                  <DropdownItem>Action</DropdownItem>
                  <DropdownItem>Another action</DropdownItem>
                  <DropdownItem>Something else here</DropdownItem>
                  <DropdownItem divider />
                  <DropdownItem>Separated link</DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
            </ButtonGroup>
          </Col>
        </Row>
        <Row className="mt-1 mb-2">
          <div className='table-responsive'>
            <TableContainerReactTable
              columns={columns}
              data={data}
              isGlobalFilter={false}
              customPageSize={5}
              divClass="mb-0"
              tableClass="table-centered align-middle table-nowrap mb-0"
              theadClass="table-light"
              thClass="px-3 py-2"
              verticalLines={true}
            />
          </div>
        </Row>
      </fieldset>
    </div>
  );
};

export default StockTab;
